export const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    style={{ marginRight: "6px" }}
    className={"trashIcon"}
  >
    <path
      d="M2.23047 6.35156V15.129C2.23047 16.0969 3.00701 16.8845 3.96124 16.8845H12.0382C12.9924 16.8845 13.7689 16.0969 13.7689 15.129V6.35156H2.23047ZM5.69201 13.9587C5.69201 14.2817 5.43355 14.5439 5.11508 14.5439C4.79662 14.5439 4.53816 14.2817 4.53816 13.9587V8.69222C4.53816 8.36921 4.79662 8.10706 5.11508 8.10706C5.43355 8.10706 5.69201 8.36921 5.69201 8.69222V13.9587ZM8.57662 13.9587C8.57662 14.2817 8.31816 14.5439 7.9997 14.5439C7.68124 14.5439 7.42278 14.2817 7.42278 13.9587V8.69222C7.42278 8.36921 7.68124 8.10706 7.9997 8.10706C8.31816 8.10706 8.57662 8.36921 8.57662 8.69222V13.9587ZM11.4612 13.9587C11.4612 14.2817 11.2028 14.5439 10.8843 14.5439C10.5659 14.5439 10.3074 14.2817 10.3074 13.9587V8.69222C10.3074 8.36921 10.5659 8.10706 10.8843 8.10706C11.2028 8.10706 11.4612 8.36921 11.4612 8.69222V13.9587Z"
      fill="currentColor"
    />
    <path
      d="M14.3462 2.84066H10.8846V2.25549C10.8846 1.28763 10.1081 0.5 9.15385 0.5H6.84615C5.89192 0.5 5.11538 1.28763 5.11538 2.25549V2.84066H1.65385C1.0175 2.84066 0.5 3.36555 0.5 4.01099V4.59615C0.5 4.91916 0.758462 5.18132 1.07692 5.18132H14.9231C15.2415 5.18132 15.5 4.91916 15.5 4.59615V4.01099C15.5 3.36555 14.9825 2.84066 14.3462 2.84066ZM6.26923 2.25549C6.26923 1.93307 6.52827 1.67033 6.84615 1.67033H9.15385C9.47173 1.67033 9.73077 1.93307 9.73077 2.25549V2.84066H6.26923V2.25549Z"
      fill="currentColor"
    />
  </svg>
);
